<div class="border p-3 rounded shadow-sm">
    <div class="row g-2 align-items-center">
        <div class="col-lg-5">
            <div class="row">
                <div class="col-6">
                    <p class="mb-1"><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
                    <p class="mb-1"><strong>Name</strong> : {{vendorName}}</p>
                </div>
                <div class="col-6">
                    <p class="mb-1"><strong>Telephone</strong> : {{telephone | phoneFormat}}</p>
                    <p class="mb-1"><strong>Email</strong> : {{Email}}</p>
                </div>
            </div>
        </div>
        <div class="col-lg-7 d-flex align-items-center gap-2">
            <!-- <button class="btn btnAS me-1">Create New</button> -->
            <button class="btn btn-orange" (click)="goBack()">Back</button>
        </div>
    </div>
    <hr />
    <div class="row">
        <div class="col-12 text-start my-2">
            <h6 class="fw-bold">Web Inquiry Login Details</h6>
        </div>
    </div>
    <form class="row g-4" [formGroup]="webInquiryForm">
        <div class="col-md-6 col-lg-4 text-start">
            <div class="mb-3">
                <label for="webUserEmail" class="form-label">User Email</label>
                <input type="text" class="form-control" id="webUserEmail" formControlName="EmailId" autocomplete="off"
                    readonly />
            </div>

            <div class="mb-3">
                <label for="webUserPassword" class="form-label">Password<span class="text-danger">*</span></label>
                <input type="password" class="form-control" id="webUserPassword" formControlName="Password"
                    maxlength="12" />
            </div>

            <div class="mb-3">
                <label for="RegDate" class="form-label">Reg Date</label>
                <input type="date" class="form-control" id="RegDate" formControlName="RegDate" />
            </div>
        </div>

        <div class="col-md-6 col-lg-4 text-start">
            <div class="mb-3" [hidden]="true">
                <label for="HintQuestion" class="form-label">Hint Question</label>
                <select class="form-select" id="HintQuestion" formControlName="SecretQuestionId">
                    <option [value]="null" disabled>--Select--</option>
                    @for (h of hintQuestions; track h.Id) {
                    <option [value]="h.Id">{{ h.Name }}</option>
                    }
                </select>
            </div>

            <div class="mb-3" [hidden]="true">
                <label for="HintAnswer" class="form-label">Hint Answer</label>
                <input type="text" class="form-control" id="HintAnswer" formControlName="SecretAnswer" />
            </div>

            <div class="form-check mt-5">
                <input type="checkbox" class="form-check-input" id="ActivateAccess"
                    formControlName="AllowOnlineAccess" />
                <label class="form-check-label" for="ActivateAccess">Activate Online Access</label>
            </div>
        </div>

    </form>
</div>
<div class="row">
    <div class="col-12 text-end my-2">
        <button class="btn btnAS me-1" (click)="saveWebInquiryUser(true)">Save & Email</button>
        <button class="btn btnAS me-1" (click)="sendEmail(true)">Email</button>
        <button type="button" class="btn btnAS me-1" (click)="saveWebInquiryUser()">Save</button>
        <button type="button" class="btn btn-orange" (click)="goBack()">Cancel</button>
    </div>
</div>